import { render } from "./login-backup.vue?vue&type=template&id=09268e6e&scoped=true"
import script from "./login-backup.vue?vue&type=script&lang=js"
export * from "./login-backup.vue?vue&type=script&lang=js"

import "./login-backup.vue?vue&type=style&index=0&id=09268e6e&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09268e6e"]])

export default __exports__